import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { downloadSchedules } from "ContentActions";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  COMMON_FAIL_MESSAGE,
  ACCESS_FILES_API_KEY,
  BASE_IMAGES_LOCAL_URL,
  BASE_IMAGES_URL,
} from "Constants";
import LocaleStrings from "Languages";

class DownloadSchedules extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  download_file = (response) => {
    let fileName = response.filename;
    let fileURL = response.successS3
      ? BASE_IMAGES_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY
      : BASE_IMAGES_LOCAL_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY;

    // for non-IE
    if (!window.ActiveXObject) {
      var save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
      save.download = fileName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search("Chrome") < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        var evt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    } else if (!!window.ActiveXObject && document.execCommand) {
      var _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, fileName || fileURL);
      _window.close();
    }
  };

  downloadSchedules = (e) => {
    this.setState({ loading: true });
    this.props.downloadSchedules(this.props.session, (response) => {
      this.setState({ loading: false });

      if (response.success === 0) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.download_file(response);
      }
    });
  };

  render() {
    var {} = this.props;

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          bsStyle=""
          onClick={(e) => this.downloadSchedules(e)}
          loading={this.state.loading}
        >
          <i className="fa fa-download i-custom-ms" aria-hidden="true" />
          {LocaleStrings.button_download}
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  downloadSchedules,
})(DownloadSchedules);
